import { render, staticRenderFns } from "./GlobalMessages.vue?vue&type=template&id=4218ec1a"
import script from "./GlobalMessages.vue?vue&type=script&lang=js"
export * from "./GlobalMessages.vue?vue&type=script&lang=js"
import style0 from "./GlobalMessages.vue?vue&type=style&index=0&id=4218ec1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports